export type ImageFitMode = 'clip' | 'scale' | 'crop';
export type ImageFormat = 'gif' | 'png' |'png8' | 'jpg' | 'pjpg' |'webp'| 'mp4';
export type ImageCompression = 'lossless' | 'lossy';

